import React, { Component, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
const Donutchart = () => {
    const [state, setstate] = useState({

        series: [44, 55, 41, 17],
        options: {
            chart: {
                type: 'donut',
            },
            labels: ['USA', 'UK', 'Australia ', 'Europe'],
            fill: {
                colors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44']
            },
            legend: {
                position: 'bottom',
                markers: {
                    fillColors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44']
                }
            },
            dataLabels: {
                enabled: false
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },


    })

    return (
        <div>
            <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="donut" />
            </div>
        </div>
    );
}


export default Donutchart;
